import { useEffect, useState } from 'react';
import getVideoData from 'services/wistiaVideoService';

const getVideoRatio = (url) => {
  const [ratio, setRatio] = useState();

  useEffect(() => {
    (async () => {
      const formattedUrl = url?.trim();
      if (formattedUrl) {
        const data = await getVideoData(formattedUrl);

        if (data) {
          setRatio(data.width / data.height);
        }
      }
    })();
  }, []);

  return ratio;
};

export default getVideoRatio;
